export default {"src":"/frontend-static/_next/static/media/share.087d8666.svg","height":447,"width":340,"blurWidth":0,"blurHeight":0};